import { api } from 'utility';
import { getClientListsReportUrl } from 'URLs';
// Cards
export function getClients(params) {
  return api.get(getClientListsReportUrl(), { params }).then((res) => res.data);
}

export default {
  getClients,
};
